export const ALL_TOPICS: Record<string, string[]> = {
    "TYT - Türkçe": [
        "Sözcükte Anlam",
        "Cümlede Anlam",
        "Paragrafın Yapısı",
        "Paragrafta Anlam",
        "Biçim Bilgisi",
        "Ses Bilgisi",
        "Yazım Kuralları",
        "Noktalama İşaretleri",
        "İsim Soylu Sözcükler",
        "Fiiller",
        "Cümlenin Ögeleri",
        "Cümle Türleri",
        "Anlatım Bozukluğu"
    ],
    "TYT - Matematik": [
        "Sayı Kümeleri",
        "Bölünebilme Kuralları",
        "1. Dereceden Denklem ve Eşitsizlikler",
        "Üslü İfadeler ve Denklemler",
        "Denklem ve Eşitsizlik Uygulamaları (Problemler)",
        "Önermeler ve Mantık",
        "Kümeler",
        "Sıralama ve Seçme",
        "Olasılık",
        "Fonksiyonlar",
        "Polinomlar",
        "İstatistik (Veri)"
    ],
    "TYT - Geometri": [
        "Üçgenlerde Temel Kavramlar",
        "Üçgenlerde Eşlik ve Benzerlik",
        "Dik Üçgen ve Trigonometri",
        "Üçgenin Alanı",
        "Çokgenler ve Dörtgenler",
        "Özel Dörtgenler",
        "Katı Cisimler"
    ],
    "TYT - Fizik": [
        "Madde ve Özkütle",
        "Hareket ve Kuvvet",
        "Newton'ın Hareket Yasaları",
        "İş Güç ve Enerji",
        "Isı Sıcaklık ve Genleşme",
        "Elektrostatik ve Devreler",
        "Basınç ve Kaldırma Kuvveti",
        "Dalgalar",
        "Optik"
    ],
    "TYT - Kimya": [
        "Kimya Bilimi",
        "Atom ve Periyodik Sistem",
        "Kimyasal Türler Arası Etkileşimler",
        "Maddenin Halleri",
        "Doğa ve Kimya",
        "Kimyanın Temel Kanunları",
        "Karışımlar",
        "Asitler Bazlar ve Tuzlar"
    ],
    "TYT - Biyoloji": [
        "Canlıların Ortak Özellikleri",
        "Canlıların Temel Bileşenleri",
        "Hücre ve Organeller",
        "Sınıflandırma",
        "Üreme (Mitoz-Mayoz)",
        "Kalıtım",
        "Ekoloji"
    ],
    "TYT - Tarih": [
        "Coğrafya ile Oluşan Yaşam Tarzı",
        "Boylardan Devlete",
        "Kavimler Göçü",
        "Türklerin İslamiyet’i Kabulü",
        "İslamiyet’in Türk Devlet ve Toplum Yapısına Etkisi",
        "Büyük Selçuklu Devleti (1040- 1157)",
        "Anadolu’nun İlk Türk Siyasi Teşekkülleri",
        "Devletleşme Sürecinde Osmanlı-Bizans İlişkileri",
        "Osmanlı Devleti’nin Rumeli’deki İskân ve İstimâlet Politikası",
        "Saray ve Şehir Kültürü",
        "Tek Hanedan Anlayışı ve Gelenekler Işığında Devlet İdarecisi",
        "Uzun Savaşlardan Diplomasiye",
        "Osmanlı Devleti’nde Demokratikleşme Hareketleri",
        "Osmanlı Devleti’nde Sanayileşme Çabaları",
        "Millî Mücadele’ye Hazırlık Dönemi",
        "Büyük Millet Meclisinin Açılması (23 Nisan 1920)",
        "Batı Cephesi ve Bu Cephede Öne Çıkan Şahsiyetler",
        "Millî Mücadele’nin Sona Ermesi ve Lozan Barış Antlaşması",
        "Atatürk İlkeleri",
        "Eğitim ve Kültür Alanındaki İnkılaplar"
    ],
    "TYT - Coğrafya": [
        "Doğa ve İnsan Etkileşimi",
        "Coğrafya Bilimi ve Bölümlenmesi",
        "Dünya’nın Şekli ve Hareketleri",
        "Coğrafi Koordinat Sistemi",
        "Harita Okuryazarlığı",
        "Atmosfer ve İklim Bilgisi",
        "Dünya’nın Yapısı ve Oluşum Süreci",
        "Su Kaynakları",
        "Topraklar",
        "Bitkiler",
        "Yerleşmeler",
        "Nüfus ve Göç",
        "Ekonomik Faaliyetler",
        "Bölgeler",
        "Uluslararası Ulaşım Hatları",
        "Afetler"
    ],
    "TYT - Felsefe": [
        "Felsefenin Anlamı",
        "Felsefi Düşüncenin Ortaya Çıkışı ve Özellikleri",
        "Felsefenin İnsan ve Toplum Hayatı Üzerindeki Rolü",
        "Düşünme ve Akıl Yürütmeye İlişkin Kavramlar",
        "Düşünme ve Dil İlişkisi",
        "Felsefi Bir Görüşü veya Argümanı Sorgulama",
        "Varlık Felsefesinin Konusu ve Problemleri",
        "Varlık Felsefesi Alanındaki Çağdaş Yaklaşımlar",
        "Bilgi Felsefesinin Konusu ve Bilginin İmkânı Problemi",
        "Bilginin Kaynağı ile İlgili Görüşler",
        "Bilginin Sınırları, Ölçütü- Doğruluk ve Gerçeklik",
        "Bilim Felsefesinin Konusu ve Problemleri",
        "Bilimin Değeri-Bilim Felsefe İlişkisi-Bilim ve Hayat İlişkisi",
        "Ahlak Felsefesinin Konusu ve Temel Kavramları",
        "Ahlak Felsefesinde Özgürlük ve Sorumluluk",
        "Evrensel Ahlak Yasasını Reddeden Görüşler ve Filozoflar",
        "Ahlak Felsefesinde İyilik ve Mutluluk İlişkisi",
        "Din Felsefesinin Konusu ve Soruları",
        "Siyaset Felsefesinin Konusu ve Problemleri",
        "Sanat Felsefesinin Konusu ve Problemleri",
        "İlk Medeniyetlerin Felsefenin Doğuşuna Etkisi",
        "Anadolu’da Yaşamış Filozoflar",
        "İlk Neden (Arkhe) ve Değişim Problemi",
        "Sofistler ile Sokrates’in Bilgi ve Değer Anlayışları",
        "Platon ve Aristoteles’in Varlık, Bilgi ve Değer Anlayışı",
        "MS 2.Yüzyıl-MS 15.Yüzyıl Felsefesinin Ortaya Çıkışı",
        "İslam Felsefesinin Özellikleri, İnanç Akıl İlişkisi",
        "15-17. Yüzyıl Felsefesinde Öne Çıkan Görüşler",
        "18-19. Yüzyıl Felsefesinde Öne Çıkan Problemler ve Görüşler",
        "20. Yüzyıl Felsefesinde Bazı Ana Akımlar",
        "20. Yüzyıl Filozoflarının Görüşleri"
    ],
    "TYT - Din Kültürü": [
        "Bilgi ve İnanç",
        "Din ve İslam",
        "İslam ve İbadet",
        "Ahlak ve Değerler",
        "Allah İnsan İlişkisi",
        "Hz. Muhammed (S.A.V)",
        "Vahiy ve Akıl",
        "İslam Düşüncesinde Yorumlar, Mezhepler",
        "Din, Kültür ve Medeniyet"
    ],
    "AYT - Matematik": [
        "Temel Kavramlar",
        "Önermeler ve Bileşik Önermeler, Niceleyiciler, Tanım, Aksiyom, Teorem ve İspat Yöntemleri",
        "Kümelerde Temel Kavramlar, Kümelerde İşlemler",
        "Fonksiyon Kavramı ve Gösterimi, İki Fonksiyonun Bileşkesi ve Bir Fonksiyonun Tersi",
        "Fonksiyonlar ile İlgili Uygulamalar, Fonksiyon Dönüşümleri",
        "İkinci Dereceden Fonksiyon ve Grafikleri",
        "Polinom Kavramı ve Polinomlarda İşlemler, Polinomların Çapanlara Ayrılması",
        "İkinci Dereceden Denklemler, Karmaşık Sayılar, Denklem ve Eşitsizlik Sistemleri",
        "Permütasyon, Kombinasyon",
        "Binom",
        "Olasılık",
        "Yönlü Açılar, Trigonometrik Fonksiyonlar",
        "Kosinüs Teoremi, Sinüs Teoremi, Ters Trigonometrik Fonksiyonlar",
        "Toplam-Fark ve İki Kat Açı Formüller",
        "Trigonometrik Denklemler",
        "Üstel Fonksiyon, Logaritma Fonksiyonu",
        "Gerçek Sayı Dizileri",
        "Limit ve Süreklilik",
        "Anlık Değişim Oranı ve Türev, Türevin Uygulamaları",
        "Belirsiz İntegral, Belirli İntegral ve Uygulamaları"
    ],
    "AYT - Geometri": [
        "Üçgen, Çokgen, Dörtgen, Özel Dörtgenler",
        "Çember ve Daire",
        "Doğrunun Analitik İncelenmesi",
        "Çemberin Analitik İncelenmesi",
        "Dönüşümler",
        "Katı Cisimler"
    ],
    "AYT - Fizik": [
        "Vektörler",
        "Bağıl Hareket",
        "Newton’ın Hareket Yasaları",
        "Bir Boyutta Sabit İvmeli Hareket",
        "İki Boyutta Hareket",
        "Enerji ve Hareket",
        "İtme ve Çizgisel Momentum",
        "Tork",
        "Denge ve Denge Şartları",
        "Basit Makineler",
        "Elektriksel Kuvvet ve Elektrik Alan",
        "Elektriksel Potansiyel",
        "Düzgün Elektrik Alan ve Sığa",
        "Manyetizma ve Elektromanyetik İndüklenme",
        "Alternatif Akım",
        "Transformatörler",
        "Düzgün Çembersel Hareket",
        "Dönerek Öteleme Hareketi",
        "Açısal Momentum",
        "Kütle Çekim Kuvveti",
        "Kepler Kanunları",
        "Basit Harmonik Hareket",
        "Dalgalarda Kırınım, Girişim ve Doppler Olayı",
        "Elektromanyetik Dalgalar",
        "Atom Kavramının Tarihsel Gelişimi",
        "Büyük Patlama ve Evrenin Oluşumu",
        "Radyoaktivite",
        "Özel Görelilik",
        "Kuantum Fiziğine Giriş",
        "Fotoelektrik Olayı",
        "Compton Saçılması ve De Broglie Dalga Boyu",
        "Görüntüleme Teknolojileri",
        "Yarı İletken Teknolojisi",
        "Süper İletkenler",
        "Nanoteknoloji",
        "Laser Işınları"
    ],
    "AYT - Kimya": [
        "Atomun Kuantum Modeli",
        "Periyodik Özellikler",
        "Yükseltgenme Basamakları",
        "Gazların Özellikleri ve Gaz Yasaları",
        "İdeal Gaz Yasası",
        "Gazlarda Kinetik Teori",
        "Gaz Karışımları",
        "Derişim Birimleri",
        "Koligatif Özellikler",
        "Çözünürlük",
        "Tepkimelerde Isı Değişimi",
        "Oluşum Entalpisi",
        "Tepkime Isılarının Toplanabilirliği",
        "Tepkime Hızları",
        "Tepkime Hızını Etkileyen Faktörler",
        "Kimyasal Denge",
        "Dengeyi Etkileyen Faktörler",
        "Sulu Çözelti Dengeleri",
        "İndirgenme – Yükseltgenme Tepkimelerinde Elektrik Akımı",
        "Elektrotlar ve Elektrokimyasal Hücreler",
        "Elektrot Potansiyelleri",
        "Elektroliz",
        "Korozyon",
        "Basit Formül ve Molekül Formülü",
        "Doğada Karbon",
        "Hibritleşme – Molekül Geometrisi",
        "Hidrokarbonlar",
        "Fonksiyonel Gruplar",
        "Alkoller – Eterler",
        "Karbonil Bileşikleri",
        "Karboksilik Asitler",
        "Esterler"
    ],
    "AYT - Biyoloji": [
        "Denetleyici ve Düzenleyici Sistem, Duyu Organları",
        "Destek ve Hareket Sistemi",
        "Sindirim Sistemi",
        "Dolaşım Sistemleri",
        "Solunum Sistemi",
        "Üriner Sistem",
        "Üreme Sistemi ve Embriyonik Gelişim",
        "Komünite Ekolojisi",
        "Popülasyon Ekolojisi",
        "Nükleik Asitlerin Keşfi ve Önemi",
        "Genetik Şifre ve Protein Sentezi",
        "Canlılık ve Enerji",
        "Fotosentez",
        "Kemosentez",
        "Hücresel Solunum",
        "Bitkilerin Yapısı",
        "Bitkilerde Madde Taşınması",
        "Bitkilerde Eşeyli Üreme",
        "Canlılar ve Çevre"
    ],
    "AYT - Edebiyat": [
        "Sözcükte Anlam",
        "Cümlede Anlam",
        "Paragrafta Anlam",
        "Şiir Bilgisi",
        "Söz Sanatları",
        "Nesir Bilgisi",
        "İslamiyet Öncesi Türk Edebiyatı / Geçiş Dönemi Türk Edebiyatı",
        "Halk Edebiyatı",
        "Divan Edebiyatı",
        "Tanzimat Dönemi Türk Edebiyatı",
        "Servet-i Fünun Dönemi Türk Edebiyatı / Fecr-i Ati Dönemi Türk Edebiyatı",
        "Milli Edebiyat Dönemi Türk Edebiyatı",
        "Cumhuriyet Dönemi Türk Edebiyatı",
        "Geleneksel Türk Tiyatrosu",
        "Masal/Fabl/Destan/Halk Hikayesi",
        "Edebi Akımlar"
    ],
    "AYT - Tarih-1": [
        "İnsanlığın Hafızası Tarih",
        "İlk Çağ’da Başlıca Medeniyet Havzaları",
        "Kanunlar Doğuyor",
        "Coğrafya ile Oluşan Yaşam Tarzı",
        "Boylardan Devlete",
        "İslamiyet Yayılıyor",
        "Abbasi Devleti ve Türkler",
        "İslamiyet’in Türk Devlet ve Toplum Yapısına Etkisi",
        "Büyük Selçuklu Devleti (1040- 1157)",
        "Büyük Selçuklu Devleti’nde Yönetim ve Toplum Yapısı",
        "Anadolu’nun İlk Türk Siyasi Teşekkülleri",
        "Hilal ve Haç Mücadelesi",
        "Devletleşme Sürecinde Osmanlı-Bizans İlişkileri",
        "Osmanlı Devleti’nin Rumeli’deki İskân ve İstimâlet Politikası",
        "Osmanlı Devleti’nde Tımar Sistemi",
        "Devşirme Sistemi ve Yeniçeri Ocağı",
        "İstanbul’un Fethi ve Fethin Sonuçları",
        "Tek Hanedan Anlayışı ve Gelenekler Işığında Devlet İdarecisi",
        "Osmanlı Devleti’nde İsyanlar ve Düzeni Koruma Çabaları",
        "Osmanlı Devleti’nde Modern Orduya Geçiş",
        "Osmanlı Devleti’ne Yönelik Tehditler",
        "Osmanlı Devleti’nde Demokratikleşme Hareketleri",
        "Osmanlı Devleti’nde Sanayileşme Çabaları",
        "Mustafa Kemal’in Lider Olarak Yetişmesinde Etkili Koşullar",
        "I. Dünya Savaşı Sürecinde Osmanlı Devleti",
        "I. Dünya Savaşı’nın Sonuçları",
        "Millî Mücadele’ye Hazırlık Dönemi",
        "Doğu ve Güney Cepheleri ile Bu Cephelerde Öne Çıkan Şahsiyetler",
        "Batı Cephesi ve Bu Cephede Öne Çıkan Şahsiyetler",
        "Millî Mücadele’nin Sona Ermesi ve Lozan Barış Antlaşması",
        "Atatürk İlkeleri",
        "Siyasi Alandaki Gelişmeler",
        "Toplumsal Alandaki İnkılaplar",
        "Atatürk Dönemi Türk Dış Politikası",
        "II. Dünya Savaşı Sürecinde Türkiye"
    ],
    "AYT - Coğrafya-1": [
        "Ekosistemlerin Özellikleri ve İşleyişi",
        "Ekstrem Doğa Olayları",
        "Küresel İklim Değişikliği ve Doğa Olaylarının Geleceği",
        "Nüfus Politikaları ve Projeksiyonları",
        "Şehirler ve Kırsal Yerleşmeler",
        "Dünyada Doğal Kaynak ve Ekonomi",
        "Türkiye’de Tarım, Sanayi, Maden ve Enerji Kaynakları",
        "Ekonomi, Şehirleşme ve Göç",
        "İşlevsel Bölge ve Kalkınma Projeleri",
        "Hizmet Sektörünün Ekonomideki Yeri ve Ulaşım",
        "Türkiye’de ve Dünyada Ticaret",
        "Türkiye’de Turizm",
        "Kültür Bölgeleri ve Türk Kültürü",
        "Küreselleşen Dünya",
        "Uluslararası Örgütler",
        "Ülkeler Arası Etkileşim",
        "Jeopolitik Konum",
        "Çevre Sorunları ve Geri Dönüşüm",
        "Çevre Sorunlarının Çözümüne Yönelik Yaklaşımlar"
    ],
    "AYT - Tarih-2": [
        "Tarih Bilimi"
    ],
    "AYT - Coğrafya-2": [
        "Ekosistem"
    ],
    "AYT - Felsefe Grubu": [
        "Psikoloji"
    ],
    "AYT - Din Kültürü": [
        "İslam"
    ],
    "AYT - YDT": [
        "Kelime Bilgisi"
    ],
    "LGS - Türkçe": [
        "Fiilimsiler",
        "Cümlenin Ögeleri",
        "Fiil Çatısı",
        "Sözcükte Anlam",
        "Cümlede Anlam",
        "Cümle Çeşitleri",
        "Yazım Kuralları",
        "Paragraf",
        "Noktalama İşaretleri",
        "Anlatım Bozuklukları"
    ],
    "LGS - Matematik": [
        "Çarpanlar ve Katlar",
        "Üslü İfadeler",
        "Kareköklü İfadeler",
        "Veri Analizi",
        "Basit Olayların Olma Olasılığı",
        "Cebirsel İfadeler ve Özdeşlikler",
        "Doğrusal Denklemler",
        "Eşitsizlikler",
        "Üçgenler",
        "Eşlik ve Benzerlik",
        "Dönüşüm Geometrisi",
        "Geometrik Cisimler"
    ],
    "LGS - Fen Bilimleri": [
        "Mevsimler ve İklim",
        "DNA ve Genetik Kod",
        "Basınç",
        "Madde ve Endüstri",
        "Basit Makineler",
        "Enerji Dönüşümleri ve Çevre Bilimi",
        "Elektrik Yükleri ve Elektrik Enerjisi"
    ],
    "LGS - T.C. İnkılap Tarihi": [
        "Bir Kahraman Doğuyor",
        "Millî Uyanış - Bağımsızlık Yolunda Atılan Adımlar",
        "Millî Bir Destan - Ya İstiklâl Ya Ölüm!",
        "Atatürkçülük ve Çağdaşlaşan Türkiye",
        "Demokratikleşme Çabaları",
        "Atatürk Dönemi Türk Dış Politikası",
        "Atatürk'ün Ölümü ve Sonrası"
    ],
    "LGS - Din Kültürü": [
        "Kader İnancı",
        "Zekât ve Sadaka",
        "Din ve Hayat",
        "Hz. Muhammed'in Örnekliği",
        "Kur'an-ı Kerim ve Özellikleri"
    ],
    "LGS - Yabancı Dil": [
        "Friendship",
        "Teen Life",
        "In The Kitchen",
        "On The Phone",
        "The Internet",
        "Adventures",
        "Tourism",
        "Chores",
        "Science",
        "Natural Forces"
    ]
};
